import { Component } from '@angular/core';

@Component({
  selector: 'mprd-available-speed-skeleton',
  templateUrl: './available-speed-skeleton.component.html',
})
export class AvailableSpeedSkeletonComponent {
  constructor() {}
}
